// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import toast from "react-hot-toast";
// import Loader from "../common/Loader";
// import RichTextEditor from "../common/RichTextEditor";

// const EditAboutPageModal = ({ isOpen, onClose, content, onContentUpdated }) => {
//   const [title, setTitle] = useState("");
//   const [subtitle, setSubtitle] = useState("");
//   const [description, setDescription] = useState("");
//   const [images, setImages] = useState([]);
//   const [keyPoints, setKeyPoints] = useState([{ heading: "", points: [""] }]);
//   const [loading, setLoading] = useState(false);
//   const [valuesSection, setValuesSection] = useState({
//   mainHeading: "",
//   cards: [{ heading: "", description: "" }]
// });

//   useEffect(() => {
//     if (!content) return;
//     setTitle(content.title || "");
//     setSubtitle(content.subtitle || "");
//     setDescription(content.description?.join("\n") || "");
//     setImages(content.images || []);
//     setKeyPoints(content.keyPoints?.length ? content.keyPoints : [{ heading: "", points: [""] }]);
//     setValuesSection(
//       content.valuesSection || {
//       mainHeading: "",
//       cards: [{ heading: "", description: "" }]
//     }
//   );
//   }, [content]);

//   const uploadToCloudinary = async (file) => {
//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("upload_preset", process.env.REACT_APP_UPLOAD_PRESET);
//     const res = await axios.post(
//       `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
//       formData
//     );
//     return res.data.secure_url;
//   };

//   const handleImageUpload = async (e) => {
//     const files = e.target.files;
//     if (!files.length) return;
//     setLoading(true);
//     try {
//       const urls = await Promise.all(Array.from(files).map(uploadToCloudinary));
//       setImages([...images, ...urls]);
//       toast.success("Images uploaded successfully");
//     } catch {
//       toast.error("Image upload failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const payload = {
//         title,
//         subtitle,
//         description: description.split("\n").filter(d => d.trim()),
//         images,
//         keyPoints: keyPoints.map(kp => ({ heading: kp.heading, points: kp.points.filter(p => p) })),
//         valuesSection: {
//           mainHeading: valuesSection.mainHeading,
//           cards: valuesSection.cards.filter(c => c.heading && c.description)
//         }
//       };
//       const res = await axios.put(
//         `${process.env.REACT_APP_API_URL}/about/edit-about/${content._id}`,
//         payload
//       );
//       onContentUpdated(res.data.data);
//       // toast.success("Updated successfully");
//       onClose();
//     } catch {
//       toast.error("Failed to update content");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start pt-10 z-50 overflow-auto">
//       <div className="bg-white w-full max-w-3xl p-6 rounded relative">
//         {/* Top-right close button */}
//         <button
//           type="button"
//           onClick={onClose}
//           className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-3xl font-bold"
//         >
//           ×
//         </button>

//         <h2 className="text-xl font-bold mb-4">Edit About Page Content</h2>
//         <form onSubmit={handleSubmit} className="space-y-4">
//           <input
//             type="text"
//             placeholder="Title"
//             value={title}
//             onChange={e => setTitle(e.target.value)}
//             className="w-full border px-3 py-2 rounded"
//             required
//           />
//           <input
//             type="text"
//             placeholder="Subtitle"
//             value={subtitle}
//             onChange={e => setSubtitle(e.target.value)}
//             className="w-full border px-3 py-2 rounded"
//             required
//           />
//           <RichTextEditor
//             value={description}
//             onChange={(content) => setDescription(content)}
//             placeholder="Description"
//           />


//           {/* Image Upload */}
//           <input type="file" multiple onChange={handleImageUpload} />
//           <div className="flex flex-wrap gap-2">
//             {images.map((img, i) => (
//               <div key={i} className="relative w-24 h-24">
//                 <img src={img} className="w-full h-full object-cover rounded border" />
//                 <button
//                   type="button"
//                   onClick={() => setImages(images.filter((_, idx) => idx !== i))}
//                   className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs hover:bg-red-600"
//                 >
//                   ×
//                 </button>
//               </div>
//             ))}
//           </div>

//           {/* Key Points Section */}
//           {keyPoints.map((kp, i) => (
//             <div key={i} className="mb-2 border p-2 rounded relative">
//               {/* Delete Section */}
//               {keyPoints.length > 1 && (
//                 <button
//                   type="button"
//                   onClick={() => setKeyPoints(keyPoints.filter((_, idx) => idx !== i))}
//                   className="absolute top-1 right-1 text-red-500 text-sm"
//                 >
//                   ×
//                 </button>
//               )}
//               <input
//                 type="text"
//                 placeholder="Heading"
//                 value={kp.heading}
//                 onChange={e => { const temp = [...keyPoints]; temp[i].heading = e.target.value; setKeyPoints(temp); }}
//                 className="w-full border px-2 py-1 mb-1 rounded"
//               />
//               {kp.points.map((point, j) => (
//                 <div key={j} className="mb-2">
//                   <RichTextEditor
//                     value={point}
//                     onChange={(content) => {
//                       const temp = [...keyPoints];
//                       temp[i].points[j] = content;
//                       setKeyPoints(temp);
//                     }}
//                   />
//                   {kp.points.length > 1 && (
//                     <button
//                       type="button"
//                       className="text-red-500 text-sm mt-1"
//                       onClick={() => {
//                         const temp = [...keyPoints];
//                         temp[i].points = temp[i].points.filter((_, idx) => idx !== j);
//                         setKeyPoints(temp);
//                       }}
//                     >
//                       × Remove Point
//                     </button>
//                   )}
//                 </div>
//               ))}
//               <button
//                 type="button"
//                 className="text-blue-500 text-sm"
//                 onClick={() => { const temp = [...keyPoints]; temp[i].points.push(""); setKeyPoints(temp); }}
//               >
//                 + Add Point
//               </button>
//             </div>
//           ))}
//           <button
//             type="button"
//             className="bg-blue-500 text-white px-2 py-1 rounded text-sm"
//             onClick={() => setKeyPoints([...keyPoints, { heading: "", points: [""] }])}
//           >
//             + Add Key Point Section
//           </button>
//           {/* ================= CORE VALUES SECTION ================= */}
// <div className="border p-4 rounded space-y-3">
//   <h3 className="text-lg font-semibold">
//     Core Values Section
//   </h3>

//   <input
//     type="text"
//     placeholder="Main Heading (e.g. The core values and principles that drive us)"
//     value={valuesSection.mainHeading}
//     onChange={(e) =>
//       setValuesSection({ ...valuesSection, mainHeading: e.target.value })
//     }
//     className="w-full border px-3 py-2 rounded"
//   />

//   {valuesSection.cards.map((card, index) => (
//     <div key={index} className="border p-3 rounded relative">
//       {valuesSection.cards.length > 1 && (
//         <button
//           type="button"
//           className="absolute top-1 right-1 text-red-500"
//           onClick={() =>
//             setValuesSection({
//               ...valuesSection,
//               cards: valuesSection.cards.filter((_, i) => i !== index)
//             })
//           }
//         >
//           ×
//         </button>
//       )}

//       <input
//         type="text"
//         placeholder="Card Heading"
//         value={card.heading}
//         onChange={(e) => {
//           const temp = [...valuesSection.cards];
//           temp[index].heading = e.target.value;
//           setValuesSection({ ...valuesSection, cards: temp });
//         }}
//         className="w-full border px-2 py-1 mb-2 rounded"
//       />

//       <textarea
//         placeholder="Card Description"
//         value={card.description}
//         onChange={(e) => {
//           const temp = [...valuesSection.cards];
//           temp[index].description = e.target.value;
//           setValuesSection({ ...valuesSection, cards: temp });
//         }}
//         className="w-full border px-2 py-1 rounded"
//         rows={3}
//       />
//     </div>
//   ))}

//   <button
//     type="button"
//     className="text-blue-500 text-sm"
//     onClick={() =>
//       setValuesSection({
//         ...valuesSection,
//         cards: [...valuesSection.cards, { heading: "", description: "" }]
//       })
//     }
//   >
//     + Add Card
//   </button>
// </div>

//           <div className="flex justify-end gap-3 pt-2">
//             <button type="button" onClick={onClose} className="bg-gray-300 px-4 py-2 rounded">Cancel</button>
//             <button type="submit" disabled={loading} className="bg-orange-500 px-4 py-2 text-white rounded">
//               {loading ? <Loader /> : "Update Content"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default EditAboutPageModal;


// components/modals/EditAboutModal.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import Loader from "../common/Loader";
import { FaTimes } from "react-icons/fa";
import RichTextEditor from "../common/RichTextEditor";

const EditAboutModal = ({ isOpen, onClose, content, onContentUpdated }) => {
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [description, setDescription] = useState("");
  const [images, setImages] = useState([]);
  const [keyPoints, setKeyPoints] = useState([]);
  
  // SEO Fields
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [canonicalUrl, setCanonicalUrl] = useState("");
  
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!content) return;
    setTitle(content.title || "");
    setSubtitle(content.subtitle || "");
    setDescription(content.description?.join("\n") || "");
    setImages(content.images || []);
    setKeyPoints(content.keyPoints || []);
    
    // SEO fields
    setMetaTitle(content.metaTitle || "");
    setMetaDescription(content.metaDescription || "");
    setMetaKeywords(content.metaKeywords || "");
    setCanonicalUrl(content.canonicalUrl || "");
  }, [content]);

  // Auto-generate meta title when title changes
  useEffect(() => {
    if (title && !metaTitle) {
      setMetaTitle(`${title} | About BBSR Services`);
    }
  }, [title]);

  const uploadToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", process.env.REACT_APP_UPLOAD_PRESET);
    const res = await axios.post(`https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`, formData);
    return res.data.secure_url;
  };

  const handleImageUpload = async (e) => {
    const files = e.target.files;
    if (!files.length) return;
    setLoading(true);
    try {
      const urls = await Promise.all(Array.from(files).map(uploadToCloudinary));
      setImages([...images, ...urls]);
      toast.success("Images uploaded successfully");
    } catch { toast.error("Image upload failed"); }
    finally { setLoading(false); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        title,
        subtitle,
        description: description.split("\n").filter(d => d.trim()),
        images,
        keyPoints,
        metaTitle: metaTitle || `${title} | About BBSR Services`,
        metaDescription: metaDescription || description.split("\n").filter(d => d.trim())[0]?.substring(0, 160) || '',
        metaKeywords: metaKeywords || `${title}, about BBSR Services, business consultants`,
        canonicalUrl: canonicalUrl || 'https://www.bbsrservices.co.in/about'
      };
      const res = await axios.put(`${process.env.REACT_APP_API_URL}/about/edit-about/${content._id}`, payload);
      onContentUpdated(res.data.data);
      // toast.success("Updated successfully");
      onClose();
    } catch { toast.error("Failed to update content"); }
    finally { setLoading(false); }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start pt-10 z-50 overflow-auto">
      <div className="bg-white w-full max-w-3xl p-6 rounded">
        <div className="flex justify-between items-center w-full">
          <h2 className="text-xl font-bold mb-4">Edit About Page</h2>
          <button onClick={onClose} className="hover:text-gray-600">
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Basic Content */}
          <input
            type="text"
            placeholder="Title"
            value={title}
            onChange={e => setTitle(e.target.value)}
            className="w-full border px-3 py-2 rounded"
            required
          />
          <input
            type="text"
            placeholder="Subtitle"
            value={subtitle}
            onChange={e => setSubtitle(e.target.value)}
            className="w-full border px-3 py-2 rounded"
          />

          <div>
            <label className="block mb-1 font-medium">Description</label>
            <RichTextEditor
              value={description}
              onChange={(value) => setDescription(value)}
              placeholder="Enter description..."
              className="w-full border rounded"
            />
          </div>

          <input type="file" multiple onChange={handleImageUpload} />
          <div className="flex flex-wrap gap-2">
            {images.map((img, i) => (
              <div key={i} className="relative w-20 h-20">
                <img src={img} className="w-full h-full object-cover rounded border" />
                <button
                  type="button"
                  onClick={() => setImages(images.filter((_, index) => index !== i))}
                  className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs hover:bg-red-600"
                >
                  ×
                </button>
              </div>
            ))}
          </div>

          {/* SEO Section */}
          <div className="border-t pt-4 mt-4">
            <h3 className="text-lg font-semibold text-blue-600 mb-3">SEO Settings</h3>

            <div className="space-y-3">
              <input
                type="text"
                placeholder="Meta Title (SEO)"
                value={metaTitle}
                onChange={e => setMetaTitle(e.target.value)}
                className="w-full border px-3 py-2 rounded"
              />
              <p className="text-xs text-gray-500">{metaTitle?.length || 0}/60 characters</p>

              <textarea
                placeholder="Meta Description (SEO)"
                value={metaDescription}
                onChange={e => setMetaDescription(e.target.value)}
                rows="3"
                className="w-full border px-3 py-2 rounded"
              />
              <p className="text-xs text-gray-500">{metaDescription?.length || 0}/160 characters</p>

              <input
                type="text"
                placeholder="Meta Keywords (SEO)"
                value={metaKeywords}
                onChange={e => setMetaKeywords(e.target.value)}
                className="w-full border px-3 py-2 rounded"
              />
              <p className="text-xs text-gray-500">Separate keywords with commas</p>

              <input
                type="url"
                placeholder="Canonical URL"
                value={canonicalUrl}
                onChange={e => setCanonicalUrl(e.target.value)}
                className="w-full border px-3 py-2 rounded"
              />
            </div>
          </div>

          <div className="flex justify-end gap-3 pt-2">
            <button type="button" onClick={onClose} className="bg-gray-300 px-4 py-2 rounded">Cancel</button>
            <button type="submit" disabled={loading} className="bg-orange-500 px-4 py-2 text-white rounded">
              {loading ? <Loader /> : "Update Content"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditAboutModal;